'use client';

import type { RoomInfo } from '@/app/(pages)/results/type';
import { useEffect } from 'react';
import { updateSessionLocalFilters } from '@/app/_shared/api';

interface UpdateSessionProps {
  checkInDate: string;
  checkOutDate: string;
  capacityAdult: number;
  capacityChild: number;
  capacityChildAges: number[];
  globalCheckInDate: string;
  globalCheckOutDate: string;
  globalCapacityRooms: RoomInfo[];
  shouldUpdateLocalSession?: boolean;
  shouldUpdateGlobalSession?: boolean;
}

export const useUpdateSession = ({
  checkInDate,
  checkOutDate,
  capacityAdult,
  capacityChild,
  capacityChildAges,
  globalCheckInDate,
  globalCheckOutDate,
  globalCapacityRooms,
  shouldUpdateLocalSession,
  shouldUpdateGlobalSession,
}: UpdateSessionProps) => {
  useEffect(() => {
    if (shouldUpdateLocalSession) {
      updateSessionLocalFilters({
        checkinDate: checkInDate,
        checkoutDate: checkOutDate,
        capacityAdult,
        capacityChild,
        capacityChildAges,
        prevCheckinDate: checkInDate,
        prevCheckoutDate: checkOutDate,
      });
    }

    if (shouldUpdateGlobalSession) {
      updateSessionLocalFilters({
        globalPlaceFilter: {
          checkinDate: globalCheckInDate,
          checkoutDate: globalCheckOutDate,
          rooms: globalCapacityRooms,
        },
        globalPrevCheckinDate: globalCheckInDate,
        globalPrevCheckoutDate: globalCheckOutDate,
      });
    }
  }, []);

  return null;
};
